"use strict";
// Shared Species model - AI profiles and metadata only (NO translations!)
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SPECIES_METADATA = void 0;
exports.getSpeciesMetadata = getSpeciesMetadata;
exports.getSpeciesAIProfile = getSpeciesAIProfile;
// AI Profiles - used for fishing score calculation
const AI_PROFILES = {
    pike: {
        label: 'Pike',
        tempOpt: 12,
        tempSigma: 6,
        dawnBoost: 1.0,
        duskBoost: 1.0,
        nightBoost: 0.3,
        middayPenalty: 0.7,
        windGoodRange: [2, 7],
        windTooMuch: 12,
        moonWeight: 0.3,
        pressureWeight: 1.0
    },
    perch: {
        label: 'Perch',
        tempOpt: 17,
        tempSigma: 5,
        dawnBoost: 0.9,
        duskBoost: 0.9,
        nightBoost: 0.3,
        middayPenalty: 0.85,
        windGoodRange: [1.5, 5],
        windTooMuch: 10,
        moonWeight: 0.5,
        pressureWeight: 0.8
    },
    zander: {
        label: 'Zander',
        tempOpt: 16,
        tempSigma: 5,
        dawnBoost: 1.2,
        duskBoost: 1.25,
        nightBoost: 1.15,
        middayPenalty: 0.6,
        windGoodRange: [1, 4],
        windTooMuch: 8,
        moonWeight: 0.8,
        pressureWeight: 0.9
    },
    trout: {
        label: 'Trout',
        tempOpt: 10,
        tempSigma: 5,
        dawnBoost: 1.1,
        duskBoost: 1.1,
        nightBoost: 0.5,
        middayPenalty: 0.75,
        windGoodRange: [1, 4],
        windTooMuch: 9,
        moonWeight: 0.4,
        pressureWeight: 0.9
    },
    salmon: {
        label: 'Salmon',
        tempOpt: 11,
        tempSigma: 5,
        dawnBoost: 1.15,
        duskBoost: 1.1,
        nightBoost: 0.6,
        middayPenalty: 0.75,
        windGoodRange: [2, 6],
        windTooMuch: 10,
        moonWeight: 0.4,
        pressureWeight: 1.0
    },
    carp: {
        label: 'Carp',
        tempOpt: 18,
        tempSigma: 6,
        dawnBoost: 1.2,
        duskBoost: 1.15,
        nightBoost: 1.0,
        middayPenalty: 0.8,
        windGoodRange: [1, 5],
        windTooMuch: 9,
        moonWeight: 0.6,
        pressureWeight: 0.85
    },
    general: {
        label: 'General',
        tempOpt: 14,
        tempSigma: 7,
        dawnBoost: 1.0,
        duskBoost: 1.0,
        nightBoost: 0.4,
        middayPenalty: 0.8,
        windGoodRange: [2, 6],
        windTooMuch: 11,
        moonWeight: 0.5,
        pressureWeight: 0.9
    }
};
// Default species metadata (NO translations - those are in frontend i18n!)
exports.DEFAULT_SPECIES_METADATA = [
    { key: 'perch', icon: '🐟', isLargeSpecies: false, aiProfile: AI_PROFILES.perch },
    { key: 'pike', icon: '🦈', isLargeSpecies: true, aiProfile: AI_PROFILES.pike },
    { key: 'pikeperch', icon: '🐟', isLargeSpecies: true, aiProfile: AI_PROFILES.zander },
    { key: 'trout', icon: '🐠', isLargeSpecies: true, aiProfile: AI_PROFILES.trout },
    { key: 'salmon', icon: '🐟', isLargeSpecies: true, aiProfile: AI_PROFILES.salmon },
    { key: 'roach', icon: '🐟', isLargeSpecies: false, aiProfile: AI_PROFILES.general },
    { key: 'bream', icon: '🐟', isLargeSpecies: false, aiProfile: AI_PROFILES.general },
    { key: 'carp', icon: '🐟', isLargeSpecies: true, aiProfile: AI_PROFILES.carp },
    { key: 'tench', icon: '🐟', isLargeSpecies: false, aiProfile: AI_PROFILES.general },
    { key: 'ruffe', icon: '🐟', isLargeSpecies: false, aiProfile: AI_PROFILES.general },
    { key: 'crucian', icon: '🐟', isLargeSpecies: false, aiProfile: AI_PROFILES.general },
    { key: 'other', icon: '❓', isLargeSpecies: false, aiProfile: AI_PROFILES.general }
];
// Helper to get metadata for a species
function getSpeciesMetadata(speciesKey) {
    return exports.DEFAULT_SPECIES_METADATA.find(s => s.key === speciesKey) || null;
}
// Helper to get AI profile for a species (with fallback for custom species)
function getSpeciesAIProfile(speciesKey) {
    const metadata = getSpeciesMetadata(speciesKey);
    return metadata?.aiProfile || AI_PROFILES.general;
}
